import React from 'react';
import PropTypes from 'prop-types';

const ReadonlyInput = ({ value }) => {
    
  return (
    <>
      <input readOnly className="form-control-plaintext" value={value} />      
    </>
  );
};

ReadonlyInput.propTypes = {
  value: PropTypes.string,  // value of the field  
};

export default ReadonlyInput;